import Commentsarea from '@app/components/entity-comments/commentsarea';
import Slideover from '@app/components/slideover';
import { useCurrentChapter } from '@app/domains/chapter/hooks/useCurrentChapter';
import { Badge, ButtonBase, Link } from '@mui/material';
import { useEffect, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

export type ChapterParagraphProps = {
    paragraphId?: string;
    showBadge?: boolean | undefined;
    setCommentsOpen?: (open: boolean) => void;
    openComments?: boolean | undefined;
};

export default function ChapterParagraphComments({
    paragraphId,
    showBadge = true,
    setCommentsOpen,
    openComments = false,
}: ChapterParagraphProps) {
    const chapter = useCurrentChapter();

    const paragraph = useMemo(() => {
        if (!chapter?.paragraphs) {
            return null;
        }

        return chapter.paragraphs.find(f => f.id === paragraphId);
    }, [chapter?.paragraphs, paragraphId]);

    useEffect(() => {
        if (openComments) {
            setCommentsOpen?.(true);
        }
    }, [openComments, setCommentsOpen]);

    if (!chapter?.paragraphs) {
        return null;
    }

    return (
        <span aria-hidden="true" className="pl-15">
            <Link component={ButtonBase}>
                {showBadge && (
                    <Badge
                        color="secondary"
                        classes={{
                            badge: 'h-16 text-[0.6rem] text-gray-100',
                            colorSecondary: twMerge(
                                paragraph?.totalComments! > 0
                                    ? 'bg-purple-500 hover:bg-purple-300'
                                    : 'bg-gray-400 dark:bg-gray-800 hover:bg-blue-300'
                            ),
                        }}
                        onClick={() => setCommentsOpen?.(true)}
                        badgeContent={paragraph?.totalComments || 0}
                        showZero
                    />
                )}
                <Slideover open={openComments} onClose={() => setCommentsOpen?.(false)}>
                    <Commentsarea className="!m-0 !p-10" entityId={chapter?.entityId} paragraphId={paragraphId} />
                </Slideover>
            </Link>
        </span>
    );
}
